import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

// Reviews customers left on a destination after their application. Each call
// throws after the server's message is shown.
const call = (route, data, dispatch, showalert = false) => PostFunction({ Route: route, data, isMultipart: false, showalert, dispatch });

export const getReviews = (countryId, dispatch) => call(UrlApi.request_reviews.get_by_country, { country_id: Number(countryId) }, dispatch);

// is_active 1 shows the review on the destination's page on safrati.ai.
export const setReviewShown = (id, shown, dispatch) => call(UrlApi.request_reviews.edit, { id, is_active: shown ? 1 : 0 }, dispatch, true);

export const deleteReviews = (ids, dispatch) => call(UrlApi.request_reviews.delete, { idsrequestreviews: ids }, dispatch, true);
